module.exports = __webpack_public_path__ + "static/video-ce1177d5854e8188f9bef5185d1b8047.mp4";